import { useMachineInfo } from "common/pages/fleetV2/providers";
import { useMachineStatusProseal } from "./ProsealMachineStatusHook";
import { MachineStatusProps } from "../types";
import { useMachineStatusDSI } from "./DSIMachineStatusHook";
import { useMachineStatusProtein } from "./ProteinMachineStatusHook";


export const useMachineStatusHook = (bu?: string):()=>(MachineStatusProps | undefined) => {

    const { businessUnit } = useMachineInfo() as { machineId?: string; businessUnit?: string };
  
    bu = bu || businessUnit;
    
    //custom hook based on BUs, ideally all these hooks should be the same, 
    //but as of right now, different BUs have different ways to extract machine status
    if (!bu) return () => undefined
    if (bu === 'aseptic') return () => undefined
    if (bu === 'proseal') return useMachineStatusProseal
    if (bu === 'protein' || bu === 'pemea' || bu === 'pna' ) return useMachineStatusProtein
    if (bu === 'dsi') return useMachineStatusDSI

    //if no bu
    return () => undefined
  };
  